export const luxuryPrimary = {
  50: '#F3E2E2',
  100: '#E6C1C1',
  200: '#DA9C9C',
  300: '#CA7474',
  400: '#BC5252',
  500: '#9E3B3B',
  600: '#893434',
  700: '#702A2A',
  800: '#592222',
  900: '#401717',
  950: '#1F0B0B',
};

export const luxurySecondary = {
  50: '#F1E9DE',
  100: '#E5D2BF',
  200: '#D8BB9A',
  300: '#CAA174',
  400: '#BC8751',
  500: '#9F6F3C',
  600: '#896034',
  700: '#6F4D29',
  800: '#593E21',
  900: '#402C18',
  950: '#1F160B',
};

export const luxuryNeutral = {
  50: '#F3F1F1',
  100: '#E7E5E5',
  200: '#DCDADA',
  300: '#C9C6C6',
  400: '#A8A5A5',
  500: '#817E7E',
  600: '#575454',
  700: '#322F2F',
  800: '#272424',
  900: '#171515',
  950: '#0D0B0B',
};

export const luxuryError = {
  50: '#F1DEE7',
  100: '#E5BFD0',
  200: '#D99AB6',
  300: '#C97499',
  400: '#BC517F',
  500: '#9F3C67',
  600: '#893459',
  700: '#702A49',
  800: '#59223A',
  900: '#40182A',
  950: '#200B14',
};

export const luxurySuccess = {
  50: '#DAEDEA',
  100: '#BBE4DF',
  200: '#97D6D1',
  300: '#72C8C0',
  400: '#4FBAB1',
  500: '#3A9E96',
  600: '#338981',
  700: '#2A7069',
  800: '#215A55',
  900: '#17403E',
  950: '#0C201E',
};

export const luxuryWarning = {
  50: '#EDEBD9',
  100: '#E2DEBB',
  200: '#D5CF97',
  300: '#C8BF71',
  400: '#BAAF50',
  500: '#9D933A',
  600: '#898033',
  700: '#71692A',
  800: '#595321',
  900: '#403C17',
  950: '#201E0B',
};

export const luxuryInfo = {
  50: '#DFEBF1',
  100: '#BFD9E6',
  200: '#9BC4D9',
  300: '#74ACCA',
  400: '#5196BC',
  500: '#3C7C9F',
  600: '#346B89',
  700: '#2A5870',
  800: '#224659',
  900: '#173140',
  950: '#0B181F',
};
